import BaseApi from "./baseApi";

class committeeApi extends BaseApi {
  async createCommitteeMember(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/committee/create-committee-member",
      data: data,
      method: "post",
    });
  }

  async newSteeringMember(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/committee/new-steering-member",
      data: data,
      method: "post",
    });
  }

  async getAllCommitteMembers(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/committee/get-all-committe-members",
      data: data,
      method: "post",
    });
  }

  async deleteMember(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/committee/delete-member",
      data: data,
      method: "post",
    });
  }

  async retreatDisabledForMem(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/committee/retreat-disabled-for-Member",
      data: data,
      method: "post",
    });
  }

  async committeeAccessedRetreats(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/committee/committee-accessed-retreats",
      data: data,
      method: "post",
    });
  }

  async deleteParishMembers(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/committee/delete-parish-members",
      data: data,
      method: "post",
    });
  }
}

export default committeeApi;
